import Enquire from "../components/Enquire";
import HomeInfo from "../components/Home/HomeInfo";
import NavBar from "../components/Nav/NavBar";
import Rights from "../components/Footer"
import Slideshow from "../components/ui/slideshow";
import {slideshowImages, slideshowCaptions} from "../data/slideshowImages";
import Details from "../components/Details";
import HomeAnimation from "../components/Home/HomeAnimation";

export default function Home() {
  return ( 
    <div id='root' className="p-4">
      <NavBar />
      <HomeAnimation />
      <Details />
      <Slideshow images={slideshowImages} captions={slideshowCaptions} />
      <HomeInfo />
      <Enquire />
      <Rights />
    </div>
  );
}

//   <Slideshow images={slideshowImages} captions={slideshowCaptions} />